import { createFileRoute } from "@tanstack/react-router";
import IRSNoticeDetail from "@/pages/site/IRSNoticeDetail";

export const Route = createFileRoute("/resources/irs-notices/$noticeId")({
  component: () => <IRSNoticeDetail />,
});
